import React, { useEffect } from 'react';
import { useHistory, useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styles from './AskAiBanner.module.less';
import Button from "../../../../components/Buttons/Button";
import Icon from "../../../../components/Icons/Icon";
import useMobile from "../../../../hooks/useMobile";
import { setShowAiPopup } from "../../../../store/user";
import { notificationTagsSelector, showAIPopupSelector, userSelector } from "../../../../store/user/selectors";
import IntroduceAiPopup from "../Popups/IntroduceAiPopup";
import dnaApi from "../../../../services/Customer/dnaApi";
import routes from "../../../../references/routes";
import { fetchNotificationTags } from "../../../../store/user/actions";

const TwinkleIcon = () => (
  <svg className={styles.AskAiBannerIcon} width="90" height="82" viewBox="0 0 90 82" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M34.7539 8.34863C30.1349 14.5967 10.6582 32.6989 10.6582 44.1904C10.6873 58.5542 22.5494 70.1846 37.2354 70.1846C45.9663 70.1845 53.755 66.0463 58.6025 59.6709L63.2568 70.6191C56.6471 77.2344 47.4273 81.3417 37.2354 81.3418C17.1314 81.3418 0.848741 65.4151 0.848633 45.752C0.848633 29.2123 26.5983 7.06533 34.7539 0.483398V8.34863ZM47.0996 48.7402C46.5649 53.8043 42.3477 57.7578 37.2354 57.7578C31.761 57.7577 27.3117 53.226 27.3115 47.6514C27.3115 45.1187 28.231 42.8023 29.7461 41.0273L47.0996 48.7402ZM66.9121 28.5508C70.8774 34.3918 73.6116 40.3688 73.6211 45.752C73.6211 46.8997 73.5628 48.0344 73.4541 49.1543L70.5059 54.6025L65.4658 42.7461L63.5508 41.8945C63.0897 39.403 61.9657 36.7069 60.4375 33.9502L65.4658 31.915L66.9121 28.5508ZM39.6865 0.483398C43.4059 3.48509 50.7844 9.72451 57.7139 17.1924L55.6816 21.9189L52.8652 23.0586C47.5787 16.5043 41.9043 10.7466 39.6865 7.95801V0.483398Z"
      fill="#64C800"
    />
    <path
      d="M89.0165 37.4747L76.264 31.6837L70.5346 18.9928L64.8052 31.6837L52.0527 37.4747L64.8052 43.1424L70.5346 55.9565L76.264 43.1424L89.0165 37.4747Z"
      fill="#005550"
    />
    <circle cx="37.6441" cy="47.7562" r="10.3961" fill="#005550"/>
  </svg>
);
const AskAiBanner = () => {
  const dispatch = useDispatch();
  const isMobile = useMobile(798);
  const includeRoutes = !!useRouteMatch([
    '/customer/bloodwork',
    '/customer/age',
    '/customer/genetics-report',
    '/customer/onboarding/test-list',
    '/customer/account',
    '/customer/settings/',
    '/customer/purchase-history/',
    '/customer/summary/dashboard',
  ]);
  const excludeRoutes = !!useRouteMatch('/customer/onbo');
  const show = includeRoutes && !excludeRoutes;
  const notificationsTags = useSelector(notificationTagsSelector);
  const user = useSelector(userSelector);
  const showAIPopup = useSelector(showAIPopupSelector);
  const history = useHistory();
  const askITFirstTime = notificationsTags?.includes('suggest-to-see-ask-section');

  useEffect(() => {
    if (user) {
      dispatch(fetchNotificationTags());
    }
  }, [user, dispatch]);

  const updatePage = () => {
    dispatch(fetchNotificationTags());
  };
  return (
    <div className={`${styles.AskAiBanner} ${show ? styles.showAskAiBanner : ''}`}>
      <div className={styles.container1920}>
        <TwinkleIcon/>
        <div className={styles.AskAiBannerTextWrap}>
          <p className={styles.AskAiBannerTitle}>Ask Terra</p>
          <p className={styles.AskAiBannerText}>
            Your go-to for science-backed answers on biomarkers, activity,
            healthspan, and more!
          </p>
        </div>
        <Button
          onClick={(e) => {
            if (askITFirstTime) {
              e.preventDefault();
              dispatch(setShowAiPopup(true));
            } else {
              e.preventDefault();
              history.push(routes.customer.askIt);
            }
          }}
          id="ask-it"
          greenGlass
          superLarge={!isMobile}
          className={styles.askItBtn}
          text={(
            <span className={styles.askItBtnText}>
              {isMobile ? 'Chat' : 'Ask now'}
              <Icon
                iconName="general_arrow"
                className={styles.askItBtnArrow}
              />
            </span>
            )}
        />
      </div>
      {showAIPopup && (
        <IntroduceAiPopup
          show={showAIPopup}
          onClosePopup={async () => {
            dispatch(setShowAiPopup(false));
            await dnaApi.putNotificationsTags('suggest-to-see-ask-section');
            updatePage();
          }}
        />
      )}
    </div>
  );
};

export default AskAiBanner;
